// This plugin ensures Pinia is initialized before voix tries to use it
export default defineNuxtPlugin({
  name: 'pinia-wrapper',
  order: -50, // Run very early, before voix plugin
  enforce: 'pre', // Ensure this runs in the pre phase
  async setup(nuxtApp) {
    // Wait for the app to be fully initialized
    await nuxtApp.runWithContext(async () => {
      // This ensures the Pinia context is available
      return Promise.resolve()
    })
  }
})